import { atomWithReset } from 'jotai/utils';
import { domain } from 'modules/data';

export const qBooksMatchingPopupAccountLineItemState = atomWithReset<domain.QBooksAccountLineItem | null>(null);

export const qBooksMatchingPopupLineItemState = atomWithReset<domain.QBooksLineItem | null>(null);
